import React, { Component } from "react";
import { Alert } from "antd";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
    // Bind the method to maintain the correct 'this' context
    this.showRefreshModal = this.showRefreshModal.bind(this);
  }

  static getDerivedStateFromError(error) {
    //console.log({ error });
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log({ error, errorInfo });

    // Update state with the error and errorInfo
    this.setState({
      error,
      errorInfo
    });

    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
  }

  showRefreshModal() {
    const { error, errorInfo } = this.state;
    const modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.width = "100%";
    modal.style.height = "100%";
    modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    modal.style.display = "flex";
    modal.style.justifyContent = "center";
    modal.style.alignItems = "center";
    modal.style.zIndex = "9999";
    const modalContent = document.createElement("div");
    modalContent.style.backgroundColor = "white";
    modalContent.style.padding = "20px";
    modalContent.style.borderRadius = "8px";
    modalContent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";

    // Get error message using the local variables
    const errorMessage = error ? error.toString() : "Unknown error occurred";

    // Get component stack from errorInfo using the local variables
    const componentStack = errorInfo ? errorInfo.componentStack : "";

    // Create a unique button ID to ensure we can attach the event listener correctly
    const buttonId = "error-refresh-button-" + Date.now();

    modalContent.innerHTML = `<div style="text-align: center;"><i aria-label="icon: exclamation-circle"
                        class="anticon anticon-exclamation-circle" style="font-size: 30px; color: orange;"><svg
                            viewBox="64 64 896 896" focusable="false" class="" data-icon="exclamation-circle"
                            width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z">
                            </path>
                            <path
                                d="M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z">
                            </path>
                        </svg></i>
                    <h3 style="margin-top: 10px;">An error has occurred</h3>
                    <div style="margin: 15px 0; text-align: left; max-height: 200px; overflow-y: auto; border: 1px solid #eee; padding: 10px; background-color: #f9f9f9;">
                        <p style="font-weight: bold; color: #cf1322;">Error: ${errorMessage}</p>
                        <p style="margin-top: 10px; font-size: 12px; white-space: pre-wrap;">${componentStack}</p>
                    </div>
                    <p>Refreshing the page might fix this issue.</p>
                    <button type="button" id="${buttonId}" class="ant-btn ant-btn-primary"
                        style="margin-top: 10px;"><span>Refresh</span></button>
                </div>`;

    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    // Use setTimeout to ensure the button is in the DOM
    setTimeout(() => {
      const refreshButton = document.getElementById(buttonId);
      if (refreshButton) {
        refreshButton.addEventListener("click", () => {
          // clear cache and hard reload the page
          console.info("clear cache before reload...");
          if (caches) {
            console.info("clearing cache...");
            caches
              .keys()
              .then(function(names) {
                console.info("cache names", names);
                for (let name of names) caches.delete(name);
              })
              .catch(err => {
                console.error("error clearing cache", err);
              })
              .finally(() => {
                console.info("cache cleared");
                // cacheCleanedFlag = true;
              });
          }

          // commented as now using service worker for caching
          if (navigator) {
            if ("serviceWorker" in navigator) {
              navigator.serviceWorker
                .getRegistrations()
                .then(function(registrations) {
                  for (let registration of registrations) {
                    registration.unregister();
                  }
                })
                .catch(err => {
                  console.error("error unregistering service worker", err);
                })
                .finally(() => {
                  console.log("service worker unregistered");
                  // unregisterFlag = true;
                });
            }
          }
          console.info("now reloading...");
          setTimeout(() => {
            console.info("trigger page reload....");
            window.location.reload();
          }, 200);
        });
      } else {
        console.error("Refresh button not found in the DOM");
      }
    }, 0);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <Alert
            message="Oops! Its seems something went wrong. Please refresh your browser"
            type="error"
            style={{
              padding: "5px",
              textAlign: "center",
              width: "500px",
              margin: "0 auto 10px auto"
            }}
          />
          {this.showRefreshModal()}
        </div>
      );
    }

    return this.props.children;
  }
}
